export const bullet_list = {
	group: "block list",
	content: "list_item+",
	attrs: {
		tight: { default: false },
	},
};
